import React, { Suspense, useLayoutEffect } from 'react'
import { BrowserRouter as Router, Route, Switch, withRouter } from 'react-router-dom';

// Required
const Preloader = React.lazy(() => import("./components/layouts/Preloader"));
const Header = React.lazy(() => import("./components/layouts/Header"));
const Footer = React.lazy(() => import("./components/layouts/Footer"));
// Home
const Home = React.lazy(() => import("./components/pages/Home"));
// About
const About = React.lazy(() => import("./components/pages/About"));
// Blog
const Blog = React.lazy(() => import("./components/pages/Blog"));
const Blogleft = React.lazy(() => import("./components/pages/Blogleft"));
const Blogright = React.lazy(() => import("./components/pages/Blogright"));
const Blogdetails = React.lazy(() => import("./components/pages/Blogdetails"));
// FAQ's
const Faqs = React.lazy(() => import("./components/pages/Faqs"));
// Shop
const Shop = React.lazy(() => import("./components/pages/Shop"));
const Shopdetails = React.lazy(() => import("./components/pages/Shopdetails"));
const Wishlist = React.lazy(() => import("./components/pages/Wishlist"));
const Cart = React.lazy(() => import("./components/pages/Cart"));
const Checkout = React.lazy(() => import("./components/pages/Checkout"));
const Payment = React.lazy(() => import("./components/pages/Payment"));
const Thankyou = React.lazy(() => import("./components/pages/Thankyou"));
// Login / Register
const Login = React.lazy(() => import("./components/pages/Login"));
const Register = React.lazy(() => import("./components/pages/Register"));
// My Acount
const Account = React.lazy(() => import("./components/pages/Account"));
// Orders
const Orderlist = React.lazy(() => import("./components/pages/Orderlist"));
const Orderdetails = React.lazy(() => import("./components/pages/Orderdetails"));
// Policy
const Privacy = React.lazy(() => import("./components/pages/Privacy"));
const Termsconditions = React.lazy(() => import("./components/pages/Termsconditions"));
// Contact
const Contact = React.lazy(() => import("./components/pages/Contact"));
// Additional
const Errorpage = React.lazy(() => import("./components/pages/Errorpage"));


// Scroll to Top
const ScrollToTop = withRouter(({ children, location: { pathname } }) => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return children || null
})


function App() {
  return (
    <Router basename={"/tm/react/fudstuff/"}>
      <Suspense fallback={<div></div>}>
        <ScrollToTop>
          <Preloader />
          <Header />
          <Switch>
            {/* Home */}
            <Route exact path="/" component={Home} />
            {/* About */}
            <Route exact path="/about" component={About} />
            {/* Blog */}
            <Route exact path="/blog/cat/:catId" component={props => (<Blog {...props} key={window.location.pathname} />)} />
            <Route exact path="/blog/tag/:tagId" component={props => (<Blog {...props} key={window.location.pathname} />)} />
            <Route exact path="/blog/author/:authorId" component={props => (<Blog {...props} key={window.location.pathname} />)} />
            <Route exact path="/blog/search/:query" component={props => (<Blog {...props} key={window.location.pathname} />)} />
            <Route exact path="/blog" component={Blog} />
            <Route exact path="/blog-left" component={Blogleft} />
            <Route exact path="/blog-right" component={Blogright} />
            <Route exact path="/blog-details/:id" component={props => (<Blogdetails {...props} key={window.location.pathname} />)} />
            {/* FAQ's */}
            <Route exact path="/faq/search/:query" component={props => (<Faqs {...props} key={window.location.pathname} />)} />
            <Route exact path="/faqs" component={Faqs} />
            {/* Shop */}
            <Route exact path="/shop/search/:query" component={props => (<Shop {...props} key={window.location.pathname} />)} />
            <Route exact path="/shop/cat/:catId" component={props => (<Shop {...props} key={window.location.pathname} />)} />
            <Route exact path="/shop/tag/:tagId" component={props => (<Shop {...props} key={window.location.pathname} />)} />
            <Route exact path="/shop" component={Shop} />
            <Route exact path="/shop-details/:id" component={props => (<Shopdetails {...props} key={window.location.pathname} />)} />
            <Route exact path="/wishlist" component={Wishlist} />
            <Route exact path="/cart" component={Cart} />
            <Route exact path="/checkout" component={Checkout} />
            <Route exact path="/payment" component={Payment} />
            <Route exact path="/thankyou" component={Thankyou} />
            {/* Login / Register */}
            <Route exact path="/login" component={Login} />
            <Route exact path="/register" component={Register} />
            {/* My Account */}
            <Route exact path="/account" component={Account} />
            {/* Orders */}
            <Route exact path="/order-list" component={Orderlist} />
            <Route exact path="/order-details/:id" component={props => (<Orderdetails {...props} key={window.location.pathname} />)} />
            {/* Policy */}
            <Route exact path="/privacy" component={Privacy} />
            <Route exact path="/terms-conditions" component={Termsconditions} />
            {/* Contact */}
            <Route exact path="/contact" component={Contact} />
            {/* Error 404 */}
            <Route exact path="/error-page" component={Errorpage} />
            <Route exact component={Errorpage} />
          </Switch>
          <Footer />
        </ScrollToTop>
      </Suspense>
    </Router>
  );
}

export default App;
